import api from "../../../../../features/auth/axiosConfig";

export const categoryService = {
  fetch: async (showDeleted: boolean, page: number, pageSize: number, searchTerm: string = "") => {
    const response = await api.get(`/app/v1/pos/category`, {
      params: {
        include_deleted: showDeleted,
        pageNumber: page + 1,
        pageSize,
        searchBy: searchTerm,
      },
    });
    return response.data;
  },

  create: async (categoryData: { CategoryName: string; Type: string }) => {
    const response = await api.post("/app/v1/pos/category", categoryData);
    return response.data;
  },

  update: async (id: string, categoryData: { CategoryName: string; Type?: string }) => {
    const response = await api.put(`/app/v1/pos/category/${id}`, categoryData);
    return response.data;
  },

  delete: async (id: string | { $oid: string }) => {
    const idString = typeof id === "string" ? id : id.$oid;
    const response = await api.delete("/app/v1/pos/category", {
      data: { ids: [idString] }, // <-- backend expects array in 'ids'
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  },
};
